import { render, staticRenderFns } from "./ECommerceHeZhuDetail.vue?vue&type=template&id=6c4c548e&"
import script from "./ECommerceHeZhuDetail.vue?vue&type=script&lang=js&"
export * from "./ECommerceHeZhuDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports